import { BigNumber } from '@ethersproject/bignumber';
import { ChecksumAddress } from '@silo/types';
import { BIG_ZERO } from 'app/constants';
import { MutableDecoratedSilo } from 'app/queries/decoratedSilo';

type WithdrawalType = 'partialLending' | 'fullLending' | 'partialProtected' | 'fullProtected';

const getWithdrawalType = (isFullAmount: boolean, isProtected: boolean): WithdrawalType => {
  switch (true) {
    case !isFullAmount && !isProtected:
    default:
      return 'partialLending';
    case isFullAmount && !isProtected:
      return 'fullLending';
    case !isFullAmount && isProtected:
      return 'partialProtected';
    case isFullAmount && isProtected:
      return 'fullProtected';
  }
};

type UpdateAsset = (params: {
  draft: MutableDecoratedSilo;
  assetAddress: ChecksumAddress;
  isFullAmount: boolean;
  isProtected: boolean;
  amount: BigNumber;
}) => void;

/**
 * Mutates a decorated silo draft according to the type of withdrawal
 */
export const updateAsset: UpdateAsset = ({ draft, assetAddress, isFullAmount, isProtected, amount }) => {
  const assetToUpdate = draft.assets.find((asset) => asset.assetAddress === assetAddress);

  if (!assetToUpdate) return;

  const withdrawalType = getWithdrawalType(isFullAmount, isProtected);

  const {
    collateralBalance: previousCollateralBalance,
    totalDeposits: previousTotalDeposits,
    collateralOnlyBalance: previousCollateralOnlyBalance,
    collateralOnlyDeposits: previousCollateralOnlyDeposits,
    userBalance: previousUserBalance,
  } = assetToUpdate;

  switch (withdrawalType) {
    case 'partialLending':
      assetToUpdate.collateralBalance = previousCollateralBalance.sub(amount);
      assetToUpdate.totalDeposits = previousTotalDeposits.sub(amount);
      assetToUpdate.userBalance = previousUserBalance.add(amount);
      break;
    case 'fullLending':
      assetToUpdate.collateralBalance = BIG_ZERO;
      assetToUpdate.totalDeposits = previousTotalDeposits.sub(previousCollateralBalance);
      assetToUpdate.userBalance = previousUserBalance.add(previousCollateralBalance);
      break;
    case 'partialProtected':
      assetToUpdate.collateralOnlyBalance = previousCollateralOnlyBalance.sub(amount);
      assetToUpdate.collateralOnlyDeposits = previousCollateralOnlyDeposits.sub(amount);
      assetToUpdate.userBalance = previousUserBalance.add(amount);
      break;
    case 'fullProtected':
      assetToUpdate.collateralOnlyBalance = BIG_ZERO;
      assetToUpdate.collateralOnlyDeposits = previousCollateralOnlyDeposits.sub(previousCollateralOnlyBalance);
      assetToUpdate.userBalance = previousUserBalance.add(previousCollateralOnlyBalance);
      break;
  }
};
